import { render } from "./ReportsContainer.vue?vue&type=template&id=8e537d90&scoped=true"
import script from "./ReportsContainer.vue?vue&type=script&lang=js"
export * from "./ReportsContainer.vue?vue&type=script&lang=js"

import "./ReportsContainer.vue?vue&type=style&index=0&id=8e537d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e537d90"]])

export default __exports__